import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { organizationsService } from '../api/organizations.service';
import { ORGANIZATIONS_KEYS } from './queryKeys';
import { useToast } from '@/shared/hooks/useToast';
import type { UpdateOrganizationPayload } from '../types';

export function useUpdateOrganization(id: string) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('organizations');

  return useMutation({
    mutationFn: (payload: UpdateOrganizationPayload) => organizationsService.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.all });
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.detail(id, id) });
      toast.success({ title: t('toast.updated') });
    },
  });
}
